import { Button, Classes, Dialog, Intent, Switch } from '@blueprintjs/core'
import React from 'react'
import { getFromStorage, setInStorage } from '../../../storage'
import { isCustomizableColumn, visibleCustomizableColumnCount } from './Constants'

interface Props {
  isOpen: any
  columns: any
  onDialogClose: any
  onEnabledColumnChange: any
  storageKey: any
  enabledColumns?: any
}
export default ({ isOpen, columns, onDialogClose, onEnabledColumnChange, storageKey, enabledColumns = {} }: Props) => {
  const visibleCount = visibleCustomizableColumnCount(columns)

  return (
    <Dialog isOpen={isOpen} onClose={onDialogClose} title="Customize Columns">
      <div className={Classes.DIALOG_BODY} style={{ maxHeight: 350, overflowY: 'scroll' }}>
        <table className="bp5-compact" style={{ width: '100%', maxWidth: '300px' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left' }}>Column</th>
              <th style={{ textAlign: 'left' }}>Show Column</th>
            </tr>
          </thead>
          <tbody>
            {columns.map(c => {
              if (!isCustomizableColumn(c)) return null
              const name = c.Header || (c.id === 'thumb' ? 'Thumbnail' : null)
              const isLastVisible = c.show !== false && visibleCount <= 1
              return (
                <tr key={c.id}>
                  <td>{name}</td>
                  <td>
                    <Switch
                      checked={c.show}
                      disabled={isLastVisible}
                      onChange={e => {
                        const { checked } = e.currentTarget
                        if (!checked && visibleCustomizableColumnCount(columns) <= 1) return
                        const stored = getFromStorage(storageKey, true) || {}
                        const next = { ...stored, ...enabledColumns, [c.id]: checked }
                        setInStorage(storageKey, next, true)
                        onEnabledColumnChange(next)
                      }}
                    />
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <ul />
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button intent={Intent.PRIMARY} onClick={onDialogClose}>
            Close
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
